import image from "../../assets/images/consultchoose.png"
import Animator from "../../components/Aminator/Animator"
export default function WhyChooseUs() {
    return (
        <section className="py-[66px] overflow-hidden">
            <div className="px-6 md:px-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center max-w-6xl mx-auto">
                    {/* Left Side - Image */}
                    <div className="relative">
                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                            <img
                                src={image}
                                alt="Professional business meeting with diverse team members collaborating around a conference table"
                                className="w-full h-[600px] object-cover"
                            />
                          
                           
                        </div>

                       
                    </div>

                    {/* Right Side - Content */}
                    <div className="space-y-8 md:pl-8">
                        <Animator variant="slide" direction="left" timeout={800} delay={200}>
                        <div>
                            <h2 className="text-3xl md:text-4xl font-semibold text-[#181818] mb-14 leading-tight">
                                Why Smart Businesses Choose <span className="text-orange-500">E1X Academy</span>
                            </h2>
                        </div>
                        </Animator>
                        <Animator variant="slide" direction="left" timeout={800} delay={300}>
                        <div className="relative">
                            <div className="flex items-start gap-[19px]">
                                <div className="w-[7px] h-[190px] md:h-[163px] bg-[#F05A19] rounded-full flex-shrink-0 mt-1" />
                                <div>
                                    <h3 className="text-2xl font-medium mb-3">Hiring is Expensive. Training is Smarter.</h3>
                                    <p className="text-[#7F7F7F] leading-relaxed text-lg">
                                        It costs 3X more to recruit a new staff member than to train a current one
                                        <span className="text-lg text-[#7F7F7F]">(LinkedIn Workforce Report, 2024)</span>.
                                    </p>
                                </div>
                            </div>
                        </div>
                        </Animator>
                        <Animator variant="slide" direction="left" timeout={800} delay={400}>
                        <div className="relative">
                            <div className="space-y-4 pl-7">
                                <h3 className="text-2xl font-medium ">Performance Starts with Upskilling.</h3>
                                <p className="text-[#7F7F7F] leading-relaxed text-lg">
                                    Organizations with continuous learning cultures are 58% more prepared for future demands and show 24%
                                    higher profit margins <span className="text-lg text-[#7F7F7F]">(Deloitte Human Capital Trends)</span>.
                                </p>
                            </div>
                        </div>
                        </Animator>
                    </div>
                </div>
            </div>
        </section>
    )
}
